var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPalystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.7 0.4375C0.3625 0.775 0.25 1.3375 0.25 2.0125V26.875C0.25 27.55 0.475 28.1125 0.8125 28.45L0.925 28.5625L14.875 14.6125V14.3875L0.7 0.4375Z",
    fill: "url(#paint0_linear_3083_575)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3752 19.3375L14.7627 14.725V14.3875L19.3752 9.77502L19.4877 9.88752L25.0002 13.0375C26.5752 13.9375 26.5752 15.4 25.0002 16.3L19.3752 19.3375Z",
    fill: "url(#paint1_linear_3083_575)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4877 19.225L14.7627 14.5L0.700195 28.5625C1.2627 29.125 2.0502 29.125 3.0627 28.675L19.4877 19.225Z",
    fill: "url(#paint2_linear_3083_575)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4877 9.77494L3.0627 0.437443C2.0502 -0.125057 1.2627 -0.0125571 0.700195 0.549943L14.7627 14.4999L19.4877 9.77494Z",
    fill: "url(#paint3_linear_3083_575)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.3752 19.1124L3.0627 28.3374C2.1627 28.8999 1.3752 28.7874 0.812696 28.3374L0.700195 28.4499L0.812696 28.5624C1.3752 29.0124 2.1627 29.1249 3.0627 28.5624L19.3752 19.1124Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M0.7 28.3375C0.3625 28 0.25 27.4375 0.25 26.7625V26.875C0.25 27.55 0.475 28.1125 0.8125 28.45V28.3375H0.7ZM25 15.9625L19.375 19.1125L19.4875 19.225L25 16.075C25.7875 15.625 26.125 15.0625 26.125 14.5C26.125 15.0625 25.675 15.5125 25 15.9625Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M3.0625 0.55006L25 13.0376C25.675 13.4876 26.125 13.9376 26.125 14.5001C26.125 13.9376 25.7875 13.3751 25 12.9251L3.0625 0.43756C1.4875 -0.46244 0.25 0.21256 0.25 2.01256V2.12506C0.25 0.43756 1.4875 -0.34994 3.0625 0.55006Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3083_575",
    x1: 13.525,
    y1: 1.79875,
    x2: -5.35588,
    y2: 20.6785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3083_575",
    x1: 27.0634,
    y1: 14.5011,
    x2: -0.15818,
    y2: 14.5011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3083_575",
    x1: 16.9306,
    y1: 17.083,
    x2: -8.67218,
    y2: 42.6857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3083_575",
    x1: -2.79068,
    y1: -7.80206,
    x2: 8.6427,
    y2: 3.63132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalystore);
export default __webpack_public_path__ + "static/media/paly store.e0c8a74e4cc74dd7e7028df823e7d1ba.svg";
export { ForwardRef as ReactComponent };